import Vue from 'vue';

const ConfirmComponent = require('./ai-confirm.vue').default;

const ConfirmConstructor = Vue.extend(ConfirmComponent);

const AiMessage = (options, type = 'basic') => {
  const settings = { type };

  if (typeof options === 'string') {
    settings.title = '确 认';
    settings.message = options;
  } else {
    Object.assign(settings, options);
  }

  const data = () => (settings);

  return new Promise((resolve, reject) => {
    const ConfirmInstance = new ConfirmConstructor({
      data,
    });
    ConfirmInstance.resolve = resolve;
    ConfirmInstance.reject = reject;
    ConfirmInstance.vm = ConfirmInstance.$mount();
    ConfirmInstance.vm.visible = true;
    document.body.appendChild(ConfirmInstance.vm.$el);
  });
};

export default AiMessage;
